// Mobile Menu Component

import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function MobileMenu({ isOpen, onClose }) {
  const location = useLocation();
  
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && <div className="mobile-menu-overlay" onClick={onClose} />}
      <div className={`mobile-menu ${isOpen ? 'mobile-menu-open' : ''}`}>
        <div className="mobile-menu-header">
          <span>tbd_menu</span>
          <button className="mobile-menu-close" onClick={onClose}>×</button>
        </div>
        <nav className="mobile-menu-nav">
          <Link 
            to="/" 
            className={`mobile-nav-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={onClose}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`mobile-nav-link ${location.pathname === '/about' ? 'active' : ''}`}
            onClick={onClose}
          >
            About
          </Link>
          <Link 
            to="/contact" 
            className={`mobile-nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
            onClick={onClose}
          >
            Contact
          </Link>
        </nav>
      </div>
    </>
  );
}

export default MobileMenu;